jQuery(document).ready(function ($) {


    $('#desktop-menu .menu-item-has-children').mouseenter(function () {
        $(this).children("ul.sub-menu").slideDown( 400 , function() {
            $(this).addClass("sub-menu-open");
        });
        $(this).addClass("sub-menu-open");

    });

    $('#desktop-menu .menu-item-has-children').mouseleave(function () {
        var someElement = $(this),
            timeoutId = setTimeout(function(){
                someElement.find(".sub-menu").slideUp("slow");
                    $(this).removeClass("sub-menu-open")
            }, 220);

        someElement.data('timeoutId', timeoutId);

    });



}); // end  jQuery(document).ready
